import { numberToHex } from '../../utils/encoding/toHex.js';
export async function setStorageAt(client, { address, index, value }) {
    await client.request({
        method: `${client.mode}_setStorageAt`,
        params: [
            address,
            typeof index === 'number' ? numberToHex(index) : index,
            value,
        ],
    });
}
//# sourceMappingURL=setStorageAt.js.map